import { Box, styled } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { clearInterval, setInterval } from 'worker-timers';

import { currentTimeInTimezone, REACT_APP_VERSION } from '#shared';

import { DataContext } from '../data-context';

interface Props {
  embedded?: boolean;
}

const TimersContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'embedded',
})<{ embedded: boolean }>(({ embedded }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  flexShrink: 0,
  ...(embedded
    ? {
        position: 'relative',
      }
    : {
        position: 'fixed',
        bottom: 5,
        right: 5,
        zIndex: 100,
      }),
}));

const Time = styled('span')(({ theme: { palette, utils } }) => ({
  fontFamily: `'JetBrains Mono', monospace`,
  fontSize: utils.clamp(9, 12),
  color: palette.grey[700],
  flexShrink: 0,
}));

export const TechnicalTimers = ({ embedded = false }: Props) => {
  const [curDate, setCurDate] = useState(new Date());
  const dataContext = useContext(DataContext);
  const lastSentTime = dataContext?.lastSentTime;
  const lastReceiveTime = dataContext?.lastReceiveTime;

  useEffect(() => {
    const interval = setInterval(() => setCurDate(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const tz = 'America/New_York';

  return (
    <TimersContainer embedded={embedded}>
      <Time>Time: {currentTimeInTimezone(curDate, tz, true)} ET</Time>
      {!!lastSentTime && (
        <Time>
          Last request sent: {currentTimeInTimezone(lastSentTime, tz, true)} ET
        </Time>
      )}
      {!!lastReceiveTime && (
        <Time>
          Last response received:{' '}
          {currentTimeInTimezone(lastReceiveTime, tz, true)} ET
        </Time>
      )}
      <Time>Version: {REACT_APP_VERSION}</Time>
    </TimersContainer>
  );
};
